// dashboard-rediseno (4.7 y 4.8, firma 2): RENAME DEL LADO DEL CLIENTE.
//
// ARCHIVO EN ASCII A PROPOSITO (regla de la casa para los `.js` nuevos).
//
// LA REGLA DEL NOMBRE ES LA DEL SERVIDOR (`backend/routes/panel_routes.py`), con la MISMA tabla de
// casos en las dos pruebas (`backend/tests/fixtures/dr/nombres_rename.json`): fuera todo byte de
// control (C0 y DEL), fuera los espacios de las ORILLAS (la lista de abajo, escrita igual que la del
// servidor: `trim()` y `strip()` no quitan lo mismo), los de en medio se quedan. Vacio:
// `doc_name_empty`. Mas de 120 letras contadas por letra (`Array.from`: un emoji cuenta 1):
// `doc_name_too_long`.
//
// `renombrar` hace el POST y, con 200, deja el nombre nuevo donde el cliente lo guarda:
//   - la cache de pantallas (SOLO con las funciones exportadas de `screenDataCache.js`): una entrada
//     fresca se parcha; una FOTO de bodega se vuelve a escribir como foto (sin perder su marca); una
//     entrada vencida se deja (la proxima visita ya va al servidor);
//   - la copia local de la app (`warehouse/nombreLocal.js`), sin volver a bajar el material;
//   - la Preparacion del Panel se invalida.
// La lista del Panel la actualiza el propio Panel con lo que esto devuelve. Si el POST falla, el
// error de axios pasa TAL CUAL (el que llama lo traduce) y no se toca nada. Aqui no salen avisos.
//
// `lib/api` se pide al llamar y no arriba (la mina de `lib/api` -> `src/i18n` en las suites que
// montan el chasis sin doblarlo).
import {
  currentScreenCacheGeneration,
  hydrateScreenCache,
  readScreenCache,
  updateScreenCache,
} from './screenDataCache';
import { invalidarPreparacion } from './preparacionDelPanel';

export const TOPE_DEL_NOMBRE = 120;

function cliente() {
  return require('./api').default;
}

// Los espacios de las orillas, por su numero (la misma lista que `_ORILLA` del servidor).
const ORILLA = new Set([0x20, 0x85, 0xa0, 0x1680, 0x2000, 0x2001, 0x2002, 0x2003, 0x2004, 0x2005,
  0x2006, 0x2007, 0x2008, 0x2009, 0x200a, 0x2028, 0x2029, 0x202f, 0x205f, 0x3000, 0xfeff]);

function esControl(letra) {
  const c = letra.codePointAt(0);
  return c < 0x20 || c === 0x7f;
}

/** El nombre ya limpio. Lo que no es texto cuenta como vacio. */
export function limpiarNombre(texto) {
  if (typeof texto !== 'string') return '';
  const letras = Array.from(texto).filter((l) => !esControl(l));
  let inicio = 0;
  let fin = letras.length;
  while (inicio < fin && ORILLA.has(letras[inicio].codePointAt(0))) inicio += 1;
  while (fin > inicio && ORILLA.has(letras[fin - 1].codePointAt(0))) fin -= 1;
  return letras.slice(inicio, fin).join('');
}

/** null, 'doc_name_empty' o 'doc_name_too_long' (en ese orden). */
export function errorDelNombre(texto) {
  const limpio = limpiarNombre(texto);
  if (!limpio) return 'doc_name_empty';
  if (Array.from(limpio).length > TOPE_DEL_NOMBRE) return 'doc_name_too_long';
  return null;
}

// ---- La cache de pantallas -------------------------------------------------------------------

function cambiarNombres(lista, porId) {
  if (!Array.isArray(lista)) return lista;
  let cambio = false;
  const salida = lista.map((d) => {
    if (d && !d.publicacion_id && Object.prototype.hasOwnProperty.call(porId, d.id)
      && d.filename !== porId[d.id]) {
      cambio = true;
      return { ...d, filename: porId[d.id] };
    }
    return d;
  });
  return cambio ? salida : lista;
}

function conLista(llave) {
  return (datos, porId) => {
    if (!datos || typeof datos !== 'object' || !Array.isArray(datos[llave])) return datos;
    const lista = cambiarNombres(datos[llave], porId);
    return lista === datos[llave] ? datos : { ...datos, [llave]: lista };
  };
}

// El Historial: `document_names` va alineado posicion por posicion con `document_ids`.
function historial(datos, porId) {
  if (!Array.isArray(datos)) return datos;
  let cambio = false;
  const salida = datos.map((s) => {
    if (!s || !Array.isArray(s.document_ids) || !Array.isArray(s.document_names)) return s;
    let propio = false;
    const nombres = s.document_names.map((n, i) => {
      const id = s.document_ids[i];
      if (Object.prototype.hasOwnProperty.call(porId, id) && n !== porId[id]) {
        propio = true;
        return porId[id];
      }
      return n;
    });
    if (!propio) return s;
    cambio = true;
    return { ...s, document_names: nombres };
  });
  return cambio ? salida : datos;
}

// Pendientes: el nombre de un grupo es el del padre (lo que sigue a "Part n/N - "); el de un
// documento entero es su nombre tal cual.
function pendientes(datos, porId, padre, nombre) {
  if (!datos || typeof datos !== 'object' || !Array.isArray(datos.groups)) return datos;
  let cambio = false;
  const grupos = datos.groups.map((g) => {
    if (!g) return g;
    let nuevo = null;
    if (padre && g.parent_doc_id === padre) nuevo = nombre;
    else if (g.documento_entero && Object.prototype.hasOwnProperty.call(porId, g.group)) nuevo = porId[g.group];
    if (nuevo === null || nuevo === g.original_filename) return g;
    cambio = true;
    return { ...g, original_filename: nuevo };
  });
  return cambio ? { ...datos, groups: grupos } : datos;
}

const PARCHES = {
  dashboard: conLista('docs'),
  'study-center': conLista('docs'),
  'analytics-overview': conLista('doc_cards'),
  'study-log': historial,
};

function parcharLlave(llave, parche) {
  const entrada = readScreenCache(llave);
  if (!entrada) return;
  if (entrada.foto) {
    const nuevo = parche(entrada.data);
    if (nuevo !== entrada.data) hydrateScreenCache(llave, nuevo, currentScreenCacheGeneration());
    return;
  }
  // Una entrada vencida no se toca: parcharla la volveria fresca con el resto del dato viejo.
  if (!entrada.fresh) return;
  if (parche(entrada.data) === entrada.data) return;
  updateScreenCache(llave, (datos) => parche(datos));
}

/** Deja el nombre nuevo en la cache de pantallas y en la copia local de la app. */
export async function aplicarNombreNuevo({ user, documentos, parentDocId, name }) {
  const porId = {};
  for (const d of Array.isArray(documentos) ? documentos : []) {
    if (d && typeof d.id === 'string' && typeof d.filename === 'string') porId[d.id] = d.filename;
  }
  Object.keys(PARCHES).forEach((llave) => parcharLlave(llave, (datos) => PARCHES[llave](datos, porId)));
  parcharLlave('pending-summary', (datos) => pendientes(datos, porId, parentDocId, name));
  invalidarPreparacion();
  if (user && user.id && Object.keys(porId).length > 0) {
    try {
      const { renombrarEnLaBodega } = await import('./warehouse/nombreLocal');
      await renombrarEnLaBodega(user.id, Object.keys(porId).map((id) => ({ id, filename: porId[id] })));
    } catch (e) {
      // La copia local es lo de menos: el servidor ya tiene el nombre y la proxima foto lo trae.
    }
  }
}

/**
 * El POST de Rename. Con 200 aplica el nombre nuevo en todos lados y devuelve la respuesta del
 * servidor (`{ok, name, documentos, sin_tocar?}`); si falla, el error de axios pasa tal cual.
 */
export async function renombrar({ user, documentId, parentDocId, nombre }) {
  const cuerpo = parentDocId
    ? { parent_doc_id: parentDocId, name: nombre }
    : { document_id: documentId, name: nombre };
  const res = await cliente().post('/panel/renombrar', cuerpo);
  const datos = res && res.data ? res.data : {};
  await aplicarNombreNuevo({
    user, documentos: datos.documentos, parentDocId: parentDocId || null, name: datos.name,
  });
  return datos;
}
